import { useMediaQuery } from "@hex-insights/core";

export * from "./cache";
export * from "./filters";
export * from "./general";
export * from "./scroll";
export * from "./use-messages";

export type MessageGroupMember<U, UG> =
	| {
			user: U;
			userGroup?: undefined;
	  }
	| {
			user?: undefined;
			userGroup: UG;
	  };

export function toMessageGroupMembers<U, UG>(users: U[], userGroups: UG[]): MessageGroupMember<U, UG>[] {
	return [...userGroups.map((userGroup) => ({ userGroup })), ...users.map((user) => ({ user }))];
}

export function useIsScreenWideForSideList() {
	return useMediaQuery("(min-width: 1100px)");
}
